import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=4fb1e0d6&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb1e0d6')) {
      api.createRecord('4fb1e0d6', component.options)
    } else {
      api.reload('4fb1e0d6', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=4fb1e0d6&", function () {
      api.rerender('4fb1e0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/comp/starrating.vue"
export default component.exports